<ng-template>
  <span *ngIf="disabled" class="child-button disabled">{{ label }}</span>

  <a *ngIf="!disabled" role="button" (click)="buttonClick()">{{ label }}</a>
</ng-template>
